import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { AccentColor } from 'helpers/AccentColorHelper';

import FlatButton from 'material-ui/FlatButton';
import { CSSTransitionGroup } from 'react-transition-group';
import { deepDiver } from 'helpers/utilities';
import { formatPhone, toFriendlyDateString } from 'helpers/Formatter';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { unitAndPropertyName } from 'helpers/StringHelper';
import { withStyles } from '@material-ui/core/styles';
import { getTranslatedString } from 'helpers/i18n';
import { tenantResidentVerbiage } from 'helpers/StringHelper';

import capitalize from 'lodash/capitalize';

const styles = {
  transactionCard: {
    color: '#424242 !important',
    fontFamily: '"Circular", sans-serif !important',
    height: '100%',
    overflow: 'hidden',
    borderRadius: '8px',
    padding: '0px',
  },
  icon: {
    width: '30px',
  },
  tag: {
    position: 'relative',
  },
};

const StyledCardContent = withStyles({
  root: {
    padding: '8px',
  },
})(CardContent);

export class DuplicateLead extends Component {
  render() {
    const { existingTenant, newTenant, newLease } = this.props;

    if (!existingTenant) return null;

    const existingUnitAndProperty = unitAndPropertyName(
      deepDiver(existingTenant, 'lease.unit_number'),
      deepDiver(existingTenant, 'lease.property_name')
    );

    const newUnitAndProperty = unitAndPropertyName(
      deepDiver(newLease, 'unit'),
      deepDiver(newLease, 'property_name')
    );

    return (
      <CSSTransitionGroup
        transitionName="lease_occupied"
        transitionEnterTimeout={500}
        transitionLeaveTimeout={500}
      >
        <div className="row" style={{ margin: '20px' }}>
          <div className="col-sm-12" style={{ textAlign: 'center', marginTop: '10px' }}>
            <div style={{ fontFamily: 'Circular-Bold', fontSize: '15px', paddingBottom: '15px' }}>
              {getTranslatedString('landlordPortal.duplicateLeads.confirmTheFollowingAction', {
                tenantResident: tenantResidentVerbiage(this.props.propertyTypes),
                email: existingTenant.email,
              })}
            </div>
          </div>

          <div className="row" style={{ paddingTop: '15px' }}>
            <div className="col-sm-5" style={{ paddingLeft: '0px', paddingRight: '0px' }}>
              <Card style={styles.transactionCard}>
                <StyledCardContent expandable={true}>
                  <div>
                    <h4 style={{ padding: '0 0 10px' }}>
                      {capitalize(
                        getTranslatedString('landlordPortal.duplicateLeads.existing', {
                          tenantResident: tenantResidentVerbiage(this.props.propertyTypes),
                        })
                      )}
                    </h4>
                  </div>

                  <div>
                    <b>{getTranslatedString('landlordPortal.duplicateLeads.firstName')}</b>{' '}
                    {existingTenant.first_name} <br />
                    <b>{getTranslatedString('landlordPortal.duplicateLeads.lastName')}</b>{' '}
                    {existingTenant.last_name} <br />
                    <b>{getTranslatedString('landlordPortal.duplicateLeads.phoneNumber')}</b> <br />
                    {formatPhone(existingTenant.phone_number)} <br />
                    <b>{getTranslatedString('landlordPortal.duplicateLeads.email')}</b> <br />
                    {existingTenant.email} <br />
                    {this._renderLeaseCard(
                      existingTenant.lease,
                      existingUnitAndProperty,
                      getTranslatedString('landlordPortal.duplicateLeads.active')
                    )}
                  </div>
                </StyledCardContent>
              </Card>
            </div>

            <div className="col-sm-2" style={{ padding: '30px', paddingTop: '25%' }}>
              <img style={styles.icon} src="/right-arrow.png" alt="Merge" />
            </div>

            <div className="col-sm-5" style={{ paddingLeft: '0px', paddingRight: '0px' }}>
              <Card style={styles.transactionCard}>
                <StyledCardContent expandable={true}>
                  <div>
                    <h4 style={{ padding: '0 0 10px' }}>
                      {capitalize(
                        getTranslatedString('landlordPortal.duplicateLeads.updatedResident', {
                          tenantResident: tenantResidentVerbiage(this.props.propertyTypes),
                        })
                      )}
                    </h4>
                  </div>
                  <div>
                    <b>{getTranslatedString('landlordPortal.duplicateLeads.firstName')}</b>{' '}
                    {newTenant.first_name} <br />
                    <b>{getTranslatedString('landlordPortal.duplicateLeads.lastName')}</b>{' '}
                    {newTenant.last_name} <br />
                    <b>{getTranslatedString('landlordPortal.duplicateLeads.phoneNumber')}</b> <br />
                    {formatPhone(newTenant.phone_number)} <br />
                    <b>{getTranslatedString('landlordPortal.duplicateLeads.email')}</b> <br />
                    {newTenant.email} <br />
                    {this._renderLeaseCard(
                      existingTenant.lease,
                      existingUnitAndProperty,
                      getTranslatedString('landlordPortal.duplicateLeads.active')
                    )}
                    {this._renderNewLeaseCard(newLease, newUnitAndProperty)}
                  </div>
                </StyledCardContent>
              </Card>
            </div>
          </div>
        </div>
      </CSSTransitionGroup>
    );
  }

  _renderLeaseCard = (lease, unitAndPropertyLabel, status) => {
    if (!lease) return null;
    return (
      <Card style={{ ...styles.transactionCard, marginTop: '10px' }}>
        <StyledCardContent expandable={true}>
          <div className="row">
            <div className="col-xs-10 col-xs-offset-10" style={{ padding: 0 }}>
              <span
                style={styles.tag}
                className={`ticket_status_label_title small ${status.toLowerCase()}`}
              >
                {status}
              </span>
            </div>
          </div>
          {lease && (
            <Fragment>
              <b>{getTranslatedString('landlordPortal.duplicateLeads.leaseTerm')}</b>
              <br />
              {toFriendlyDateString(lease.start_date, {
                language: this.props.currentLanguage,
              })}{' '}
              -{' '}
              {toFriendlyDateString(lease.end_date, {
                language: this.props.currentLanguage,
              })}{' '}
              <br />
              <b>{getTranslatedString('landlordPortal.duplicateLeads.unitAndProperty')}</b>
              <br /> {unitAndPropertyLabel}
            </Fragment>
          )}
        </StyledCardContent>
      </Card>
    );
  };

  _renderNewLeaseCard = (lease, unitAndPropertyLabel) => {
    if (!lease) return null;
    return this._renderLeaseCard(
      { ...lease, start_date: lease.lease_start_date, end_date: lease.lease_end_date },
      unitAndPropertyLabel,
      getTranslatedString('landlordPortal.duplicateLeads.new')
    );
  };
}

DuplicateLead = connect((store) => ({
  currentLanguage: store.locale.currentLanguage,
  propertyTypes: store.userTypes.propertyTypes,
}))(DuplicateLead);

export class ExistingLeadError extends Component {
  render() {
    const { existingTenant } = this.props;

    if (!existingTenant) return null;

    return (
      <CSSTransitionGroup
        transitionName="lease_occupied"
        transitionEnterTimeout={500}
        transitionLeaveTimeout={500}
      >
        <div className="row" style={{ margin: '25px' }}>
          <div className="col-sm-12" style={{ textAlign: 'center', marginTop: '10px' }}>
            <div style={{ color: 'red', fontFamily: 'Circular-Bold', fontSize: '15px' }}>
              {getTranslatedString('landlordPortal.duplicateLeads.thereIsAlready', {
                tenantResident: tenantResidentVerbiage(this.props.propertyTypes),
              })}{' '}
              {existingTenant.email}
            </div>
            <div className="row" style={{ marginTop: '15px' }}>
              <div className="col-sm-4 col-sm-offset-4">
                <FlatButton
                  onClick={this.props.toggleConfirmationDialog}
                  id="confirm-button"
                  style={{ color: 'white', backgroundColor: AccentColor(), padding: '0 10px' }}
                >
                  {getTranslatedString('landlordPortal.duplicateLeads.viewAndConfirm')}
                </FlatButton>
              </div>
            </div>
          </div>
        </div>
      </CSSTransitionGroup>
    );
  }
}

ExistingLeadError = connect((store) => ({
  currentLanguage: store.locale.currentLanguage,
  propertyTypes: store.userTypes.propertyTypes,
}))(ExistingLeadError);
